// Function loadWoolLabImageBlock loads the WoolLabImageBlock class by dynamically importing the js on demand if needed

export function loadWoolLabImageBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-block-chunk" */ '../widgets/woolLabImageBlock').then(wg => {

		const { WoolLabImageBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabImageBlock"]');

		if(!$wg) {
			// console.info('WoolLabImageBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabImageBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabImageBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabImageBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabImageBlock widget');

}
